<ng-container *transloco="let t; read: 'downloads'">
  <div class="p-5">
    <div>
      <drdp-title [title]="t('ratings.title', { year: '2025' })"></drdp-title>
      <div>
        <p>{{ t('ratings2025.description') }}</p>
      </div>
    </div>
    <drdp-download-search (searchClicked)="downloadDemographics($event)" [isPilot]="true"></drdp-download-search>
  </div>

</ng-container>
